import * as React from 'react'
import {Util} from 'yougile-util'

export const DownArrow = () => {
  const bem = Util.bemFrom('down-arrow')
  return (
    <svg className={bem()} viewBox="0 0 32 32">
      <path d="M4.686,12.686l9.899,9.9c0.781,0.781,2.047,0.781,2.828,0l9.9-9.9l-2.475-2.475L16,19.05l-8.839-8.839L4.686,12.686z" />
    </svg>
  )
}
